export const createRestaurantSettings = () => ({
    comments_guest: false,
    comments_restaurant: false,
    check_delivery_time: 1,
    days: {
        monday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
        },
        tuesday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
        },
        wednesday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
        },
        thursday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
        },
        friday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
        },
        saturday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
        },
        sunday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
        },
        day: {
            monday: "",
            tuesday: "",
            wednesday: "",
            thursday: "",
            friday: "",
            saturday: "",
            sunday: "",
        },
    },
    google: "https://play.google.com/store/apps/details?id=rs.bitlab.ordera",
    apple: "https://apps.apple.com/app/id1664273786",
    huawei: "https://appgallery.huawei.com/app/C107593211",
    old_time_changes: false,
    new_time_changes: true,
    no_time_limit: false,
    receiving_orders: true,
    can_order_off: false,
    order_before_hours: "",
    language: [],
    non_working_days: [],
    guest_day: {
        new_time_changes: true,
        monday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
                delivery_from: "",
                delivery_to: "",
                delivery_from1: "",
                delivery_to1: "",
            },
        },
        tuesday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
                delivery_from: "",
                delivery_to: "",
                delivery_from1: "",
                delivery_to1: "",
            },
        },
        wednesday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
                delivery_from: "",
                delivery_to: "",
                delivery_from1: "",
                delivery_to1: "",
            },
        },
        thursday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
                delivery_from: "",
                delivery_to: "",
                delivery_from1: "",
                delivery_to1: "",
            },
        },
        friday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
                delivery_from: "",
                delivery_to: "",
                delivery_from1: "",
                delivery_to1: "",
            },
        },
        saturday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
                delivery_from: "",
                delivery_to: "",
                delivery_from1: "",
                delivery_to1: "",
            },
        },
        sunday: {
            time: {
                time_hour: "",
                time_minut: "",
            },
            day_before_limit: "",
            day_after_limit: "",
            working_hours: {
                delivery_from: "",
                delivery_to: "",
                delivery_from1: "",
                delivery_to1: "",
            },
        },
        day: {
            monday: "",
            tuesday: "",
            wednesday: "",
            thursday: "",
            friday: "",
            saturday: "",
            sunday: "",
        },
    },
    guest: {
        guest_cancel_order_time: "",
        post_description: "",
        rok_dana: false,
        meal_in_restaurant: false,
        order_before: "",
        rok_sati: false,
        dan: "",
        broj_sati: "",
        restoran_delivery: false,
        post_delivery: false,
        personal_takeover: false,
        minimal_price: 0,
        post_minimal_price: 0,
        post_price: 0,
        delivery_price: "",
        dani_bez_menija: 1,
    },
    lice_bez_ugovora: false,
    topbar: {
        background: "#FB6D3B",
    },
    footer: {
        background: "#FB6D3B",
    },
    mob: {
        primary: "#FB6D3B",
        text_toolbar_color: "#FB6D3B",
        text_color: "#FB6D3B",
        button_color: "#FB6D3B",
        baner_link_header: null,
        baner_link_footer: null,
        baner_link_restoran: null,
    },
    mobColor: {
        primary: "#FB6D3B",
        text_toolbar_color: "#FB6D3B",
        text_color: "#FB6D3B",
        button_color: "#FB6D3B",
    },
    price: null,
    primary: "#FB6D3B",
    logo: null,
    logo_mob_header: null,
    logo_mob_footer: null,
    logo_mob_restoran: null,
    facebook: null,
    instagram: null,
    twitter: null,
    linkedin: null,
    order_before: 0,
    header: null,
    restoran_image: null,
    izvestaj: false,
    ijekavica: false,
    ekavica: false,
    rok_dana: true,
    rok_sati: false,
    broj_sati: "",
    dan: "",
    worker: true,
    can_reserve: false,
    delivery_from_hour: "",
    delivery_from_min: "00",
    delivery_to_hour: "",
    delivery_to_min: "00",
});
